import { WeekdayNumber }	from "ts-base/time/weekdayNumber";

export type WeekdayName	= typeof WeekdayName.values[number];

export namespace WeekdayName {
	export const fromWeekDayNumber	= (it:WeekdayNumber):WeekdayName	=> values[it - 1];
	export const toWeekDayNumber	= (it:WeekdayName):WeekdayNumber	=> mapping[it];

	export const values	= [ "monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday" ] as const;

	const mapping:Record<WeekdayName, WeekdayNumber>	= {
		monday:		1,
		tuesday:	2,
		wednesday:	3,
		thursday:	4,
		friday:		5,
		saturday:	6,
		sunday:		7,
	};
};
